import { IconButton, Tooltip } from '@chakra-ui/react';
import { ReactElement } from 'react';

interface Props {
  buttons: {
    icon: ReactElement;
    tooltip: string;
    onClick: () => void;
  }[];
}

export function SimpleUserAvatarButtons({ buttons }: Props) {
  return (
    <>
      {buttons.map((x, i) => {
        return (
          <Tooltip key={i} label={x.tooltip}>
            <IconButton
              size="xs"
              variant="avatar-badge"
              icon={x.icon}
              onClick={x.onClick}
              aria-label={x.tooltip}
            />
          </Tooltip>
        );
      })}
    </>
  );
}
